import { render, staticRenderFns } from "./mailEdit.vue?vue&type=template&id=30cdda5a&scoped=true&"
import script from "./mailEdit.vue?vue&type=script&lang=js&"
export * from "./mailEdit.vue?vue&type=script&lang=js&"
import style0 from "./mailEdit.vue?vue&type=style&index=0&id=30cdda5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdda5a",
  null
  
)

export default component.exports